import type { CsvDelimiter, CsvQuote } from "@reporting/rp-utils-csv";

export enum IOThreadTypes {
	Import = 'IM',
	Export = 'O',
	Delete = 'D',
}

export const DELIMITERS: CsvDelimiter[] = [',', ';', '\t', '|', ' '];
export const QUOTES: CsvQuote[] = ['', '"', "'"];

export const DELIMITER_LIST: {k: CsvDelimiter, v: string}[] = [
	{ k: '\t', v: 'Tab' },
	{ k: ';', v: ';' },
	{ k: ',', v: ',' },
	{ k: '|', v: '|' },
	{ k: ' ', v: 'Space' },
];

export const ENCLOSURE_LIST: {k: CsvQuote, v: string}[] = [
	{ k: '', v: '' },
	{ k: '"', v: '"' },
	{ k: "'", v: "'" },
];

export const DECIMAL_LIST: {k: '.'|',', v: string}[] = [
	{ k: ',', v: ',' },
	{ k: '.', v: '.' },
];

export const ENCODING_LIST: {k: string, v: string}[] = [
	{ k: 'UTF-16LE', v: 'UTF-16LE (Excel)' },
	{ k: 'UTF-8', v: 'UTF-8' },
];

/** `hint` is muted text (nothing to fix yet), the others render as inline alerts. */
export type IOValidationMessageType = 'hint' | 'info' | 'warning' | 'danger';

export type IOValidationMessage = {
	id: string;
	type: IOValidationMessageType;
	text: string;
};

/** Detail of the `io.validate` event of the input container. */
export type IOValidationResult = {
	/** Whether the input can be imported; false disables the import button. */
	valid: boolean;
	messages: IOValidationMessage[];
};
